export enum Role {
  Admin = 1,
  User = 2,
}

export enum ProductId {
  AGENT = 3,
  ATS = 2,
  TALENT = 1,
}
